export default __webpack_public_path__ + "static/media/matchGray.464d650c.svg";